<ridango-block-full-width
    [isEmpty]="isEmpty"
    [removeMargin]="getProductInfoProperty(selectedProduct$ | async)"
    role="radiogroup"
    aria-labelledby="product_title">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>
    <h2 class="block-full-width__title" id="product_title">
        {{ 'CHOOSE_PRODUCT' | translate }}
    </h2>
    <div class="flex justify-center" *ngIf="isProductLoginRequired">
        <div class="flex max-w-[50%] flex-col justify-center">
            <h2 class="block-full-width__title">
                {{ 'LOGIN_REQUIRED_FOR_THIS_PRODUCT' | translate }}
            </h2>
            <button class="btn btn--primary" (click)="goToLoginPage()" tabindex="0" type="button">
                {{ 'BTN_LOG_IN' | translate }}
            </button>
        </div>
    </div>
    <div class="flex justify-center" *ngIf="isPersonalizationRequired && !isProductLoginRequired">
        <div class="flex max-w-[50%] flex-col justify-center">
            <h2 class="block-full-width__title">
                {{ 'ACCOUNT_PERSONALIZATION_REQUIRED' | translate }}
            </h2>
            <button class="btn btn--primary" (click)="goToProfilePage()" tabindex="0" type="button">
                {{ 'BTN_GO_TO_ACCOUNT_PERSONALIZATION' | translate }}
            </button>
        </div>
    </div>

    <p
        class="block-full-width-message__content__description"
        *ngIf="
            (filteredProducts$ | async).length === 0 &&
            !isEmpty &&
            !isProductNotAllowed &&
            !isProductLoginRequired &&
            !isPersonalizationRequired
        ">
        {{ 'PURCHASE_PAGE_NO_PRODUCTS_FOUND_FOR_GIVEN_FILTER_VALUES' | translate }}
    </p>
    <p
        class="block-full-width-message__content__description"
        *ngIf="isProductNotAllowed && !isProductLoginRequired && !isPersonalizationRequired">
        {{ 'PRODUCT_NOT_ALLOWED' | translate }}
    </p>
    <ridango-block-items-two
        *ngIf="
            (filteredProducts$ | async).length === 2 &&
            (filteredProducts$ | async).length > 0 &&
            !isEmpty &&
            !isProductNotAllowed &&
            !isProductLoginRequired &&
            !isPersonalizationRequired
        "
        ridangoMatchHeight="btn--big-selection__top-wrapper">
        <ridango-product-list-item
            *ngFor="let product of filteredProducts$ | async"
            [item]="product"
            [lang]="locale"
            [selected]="product.product_id === (selectedProduct$ | async)?.product_id"
            [moneyFormat]="true"
            [tabIndex]="getTabIndex(product)"
            (onItemSelected)="productSelected($event)"
            (onMovedLeft)="selectLeft($event)"
            (onMovedRight)="selectRight($event)"
            (onFocused)="focus($event)"
            (onBlurred)="blur($event)"></ridango-product-list-item>
    </ridango-block-items-two>

    <ridango-block-items-three
        *ngIf="
            (filteredProducts$ | async).length !== 2 &&
            (filteredProducts$ | async).length > 0 &&
            !isEmpty &&
            !isProductNotAllowed &&
            !isProductLoginRequired &&
            !isPersonalizationRequired
        "
        ridangoMatchHeight="btn--big-selection__top-wrapper">
        <ridango-product-list-item
            *ngFor="let product of filteredProducts$ | async"
            [item]="product"
            [lang]="locale"
            [selected]="product.product_id === (selectedProduct$ | async)?.product_id"
            [moneyFormat]="true"
            [tabIndex]="getTabIndex(product)"
            (onItemSelected)="productSelected($event)"
            (onMovedLeft)="selectLeft($event)"
            (onMovedRight)="selectRight($event)"
            (onFocused)="focus($event)"
            (onBlurred)="blur($event)"></ridango-product-list-item>
    </ridango-block-items-three>
</ridango-block-full-width>
<!-- PRODUCT ADDITIONAL INFO -->
<div class="info-popup-v2 info-popup-v2--information-v2" *ngIf="getProductInfoProperty(selectedProduct$ | async)">
    <div class="info-popup-v2__type">
        <span class="info-popup-v2__icon icon icon-circle-warning"></span>
    </div>

    <div class="info-popup-v2__title">
        {{ 'INFORMATION_V2' | translate }}
    </div>

    <div class="info-popup-v2__text">
        {{ getProductInfoProperty(selectedProduct$ | async)?.value | translate }}
    </div>
</div>

<!-- PRODUCT SMS INFO -->
<div
    class="info-popup-v2 info-popup-v2--information-v2"
    *ngIf="(selectedProduct$ | async)?.code || (selectedProduct$ | async)?.code_en">
    <div class="info-popup-v2__type">
        <span class="info-popup-v2__icon icon icon-circle-warning"></span>
    </div>

    <div class="info-popup-v2__title">
        {{ 'PHONE_PURCHASE_HEADER' | translate }}
    </div>

    <div class="info-popup-v2__text">
        <p innerHtml="{{ 'PHONE_PURCHASE_TEXT' | translate: (selectedProduct$ | async) }}"></p>
    </div>
</div>
